import axios from 'axios';
import type { IssuesUiConfig } from 'utils/issueDueDateColor';

export const getOptionManufactures = async (params?: { page: number }) => {
  const { data } = await axios.get('/manufacturers', { params });
  return data;
};

export const getAllOption = async () => {
  const { data } = await axios.get('/system/options');
  return data;
};
type TypePayloadCreateOption = {
  name: string;
  value: string;
  dropdownValueOptionId: number;
};
export const createNewOption = async (payload: TypePayloadCreateOption[]) => {
  const { data } = await axios.post('/system/dropdown-values', { data: payload });
  return data;
};
export const updateDropdownValueParent = async (
  payload: { id: number } & Record<string, string | boolean | number[]>
) => {
  const { id, ...rest } = payload;
  const { data } = await axios.put(`/system/${id}/dropdown-value-parent`, rest);
  return data;
};

export const updateOptionType = async (payload: string[], id: number) => {
  const { data } = await axios.put(`/system/${id}/options`, { type: payload });
  return data;
};

export const updateOption = async ({
  id,
  payload
}: {
  id: number;
  payload: Partial<TypePayloadCreateOption>;
}) => {
  const { data } = await axios.put(`/system/dropdown-values/${id}`, {
    value: payload.value
  });
  return data;
};

export const deleteOption = async ({ id }: { id: number }) => {
  const { data } = await axios.delete(`/system/dropdown-values/${id}`);
  return data;
};

export const deleteDropdown = async ({ id }: { id: number }) => {
  const { data } = await axios.delete(`/system/dropdown-value-option/${id}`);
  return data;
};
export const getOptionsSet = async () => {
  const { data } = await axios.get('/system/export-options-set');
  return data;
};
export const createOptionsSet = async (payload: { name: string; options: string[] }) => {
  const { data } = await axios.post('/system/export-options-set', payload);
  return data;
};
export const updateOptionsSet = async (
  id: number,
  payload: { name?: string; options?: string[] }
) => {
  const { data } = await axios.put(`/system/export-options-set/${id}`, payload);
  return data;
};
export const deleteOptionsSet = async (id: number) => {
  const { data } = await axios.delete(`/system/export-options-set/${id}`);
  return data;
};
export type CreateSingleDataEntryField = {
  type: string;
  entries: string[];
  name: string;
  required: boolean;
  clientIds?: number[];
};
export const getSingleEntryFields = async () => {
  const { data } = await axios.get('/system/single-entry-fields');
  return data;
};
export const createSingleEntryFields = async (payload: CreateSingleDataEntryField) => {
  const { data } = await axios.post('/system/single-entry-fields', payload);
  return data;
};
export const updateSingleEntryFields = async (
  id: number,
  payload: Partial<CreateSingleDataEntryField>
) => {
  const { data } = await axios.put(`/system/single-entry-fields/${id}`, payload);
  return data;
};
export const deleteSingleEntryFields = async (id: number) => {
  const { data } = await axios.delete(`/system/single-entry-fields/${id}`);
  return data;
};

export const getIssuesConfig = async () => {
  const { data } = await axios.get('/system/issues-config');
  return data as { success: boolean; config: IssuesUiConfig };
};

export const updateIssuesConfig = async (payload: Partial<IssuesUiConfig>) => {
  const { data } = await axios.put('/system/issues-config', payload);
  return data as { success: boolean; config: IssuesUiConfig };
};

//////

export const getAllOptionStartInspection = async () => {
  try {
    const { data } = await axios.get('system/dropdown-values');
    return data;
  } catch (e) {
    console.log(e);
  }
};
/**
 *
 * get system dropdown values
 */
export const getSystemDropdownValues = async () => {
  const { data } = await axios.get('/system/options');
  return data;
};
export interface SingleEntryField {
  id: number;
  required: boolean;
  name: string;
  entries: string[];
  type: 'DATE' | 'TEXT';
  singleDataEntryClients?: { clientId: number; client: { id: number; clientName: string } }[];
}
/**
 *
 * get asset types
 */
export const getAssetTypes = async (params: { page: number; size: number }) => {
  const { data } = await axios.get('assets/types', { params });
  return data;
};

/**
 *
 * get asset model
 */
export const getAssetModels = async (params: { page: number; size: number }) => {
  const { data } = await axios.get('assets/models', { params });
  return data;
};
/**
 *
 * @function get manuafactures
 */
export const getManufactures = async (params: { page?: number; size?: number }) => {
  const { data } = await axios.get(`manufacturers`, { params });
  return data;
};
/**
 *
 * get users
 */
export const getUsers = async (params: { page: number; size: number }) => {
  const { data } = await axios.get('users', { params });
  return data;
};
